import React from 'react';
import logo from 'assets/img/biz-capital-logo-2019.png';
import poligonoLogo from 'assets/img/poligono.png';
import { POLIGONO_BRAND, getProductBrand } from 'constants/brand-constants';
import './bizon-screen-wrapper.styles.scss';

const BizonScreenWrapper: React.FC = ({ children }): JSX.Element => {
    const isPoligono = getProductBrand().branchName === POLIGONO_BRAND.branchName;

    return (
        <div className="bizon-screen-wrapper">
            <div className="bizon-screen-wrapper__header">
                <div className="bizon-screen-wrapper__logo grid-container">
                    <img
                        src={isPoligono ? poligonoLogo : logo}
                        alt={isPoligono ? 'poligono-logo' : 'bizcap-logo'}
                        className={isPoligono ? 'poligono-logo bizcap-logo' : 'bizcap-logo'}
                    />
                </div>
            </div>
            <div className="bizon-screen-wrapper__content">
                {children}
            </div>
        </div>
    );
};

export default BizonScreenWrapper;
